<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-card-title class="time-map-title"> Mapa do Tempo </v-card-title>
        <p></p>
        <v-card-subtitle class="time-map-subtitle">
          Conheça os produtos de previsão do tempo do Simepar.
        </v-card-subtitle>
        <br />
        <v-card-actions>
          <v-slide-group
            style="margin-left: auto; margin-right: auto"
            v-model="mapSelected"
          >
            <v-slide-item
              v-for="(item, index) in mapList"
              :key="index"
              v-slot="{ active, toggle }"
            >
              <v-btn
                large
                rounded
                outlined
                class="mr-2"
                :input-value="active"
                active-class="secondary white--text"
                @click="toggle"
              >
                <span style="font-size: 1rem">{{ item.text }}</span>
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-card-actions>
        <v-card-text>
          <animation-time-map
            :mapItem="mapList[mapSelected]"
          ></animation-time-map>
        </v-card-text>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AnimationTimeMap from "./AnimationTimeMap.vue";
export default {
  components: { AnimationTimeMap },
  name: "TimeMap",
  data: () => ({
    mapSelected: 0,
    mapList: [
      {
        text: "Radar Meterológico",
      },
      {
        text: "Chuva",
      },
      {
        text: "Temperatura",
      },
      {
        text: "Vento",
      },
    ],
  }),
};
</script>

<style scoped>
@font-face {
  font-family: 'Poppins';
  src: local('Poppins'), url('../../assets/fonts/Poppins/Poppins-SemiBold.ttf') format("truetype");
}

@font-face {
  font-family: 'Questrial';
  src: local('Questrial'), url('../../assets/fonts/Questrial/Questrial-Regular.ttf') format("truetype");
}

.time-map-title {
  left: 113px;
  top: 7px;
  font-family: "Questrial", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 2rem;
  line-height: 33px !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  color: #ffffff;
}

.time-map-subtitle {
  height: 24px;
  left: 0px;
  top: 61px;

  font-family: "Poppins", sans-serif !important;
  font-style: normal;
  font-weight: 300px;
  font-size: 1rem;
  line-height: 33px !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  color: #ffffff;
}
</style>
